import { render } from "./ContentBase.vue?vue&type=template&id=eec66c8e&scoped=true"
import script from "./ContentBase.vue?vue&type=script&lang=js"
export * from "./ContentBase.vue?vue&type=script&lang=js"

import "./ContentBase.vue?vue&type=style&index=0&id=eec66c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec66c8e"]])

export default __exports__